export const SUPPORT_EMAIL = 'support@flirtify.com';
export const MODELS_SUPPORT_EMAIL = 'model@flirtify.com';
export const NO_REPLY_EMAIL = 'no-reply@flirtify.com';
export const PRIORITY_BILL_SUPPORT = 'support@prioritybill.com';
